import StatContent from './StatContent';

export default StatContent;
